/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { token } from "@panda/tokens";

export const getGistStyleTag = (): string => `
    <style type="text/css">
		body {
			margin: 0;
		}
		body .gist .gist-file {
			margin-bottom: 0;
			--bgColor-default: ${token("colors.eds.background.elevated.low.default")};
		}
        body .gist .blob-code-inner {
            color: ${token("colors.eds.palette.grayscale.gray120")};
        }
        body .gist .blob-num,
        body .gist .pl-st {
            color: ${token("colors.eds.text.secondary")};
        }
        body .gist .pl-c,
        body .gist .pl-c span {
            color: ${token("colors.eds.palette.grayscale.gray090")};
        }
        body .gist .pl-mb {
            color: ${token("colors.eds.palette.accent.blue200")};
        }
        body .gist .pl-mh .pl-en {
            color: ${token("colors.eds.palette.accentTone.yellow300")};
            font-weight: 700;
        }
        body .gist .pl-mi {
            color: ${token("colors.eds.palette.accent.green200")};
        }
        body .gist .pl-mq {
            color: ${token("colors.eds.palette.grayscale.gray070")};
        }
        body .gist .pl-sc {
            color: ${token("colors.eds.palette.grayscale.gray110")};
        }
        body .gist .pl-c1,
        body .gist .pl-mh,
        body .gist .pl-sr .pl-cce {
            color: ${token("colors.eds.palette.accent.yellow200")};
        }
        body .gist .pl-e,
        body .gist .pl-en,
        body .gist .pl-ent {
            color: ${token("colors.eds.palette.accentTone.purple300")};
        }
        body .gist .pl-pds,
        body .gist .pl-s1,
        body .gist .pl-s1 .pl-pse .pl-s2,
        body .gist .pl-s,
        body .gist .pl-v,
        body .gist .pl-vpf {
            color: ${token("colors.eds.palette.accentTone.blue300")};
        }
        body .gist .pl-k,
        body .gist .pl-mdh,
        body .gist .pl-mdr,
        body .gist .pl-ml,
        body .gist .pl-mm,
        body .gist .pl-mo,
        body .gist .pl-mp,
        body .gist .pl-mr,
        body .gist .pl-ms,
        body .gist .pl-s1 .pl-v,
        body .gist .pl-s3,
        body .gist .pl-sr,
        body .gist .pl-sr .pl-sra,
        body .gist .pl-sr .pl-sre,
        body .gist .pl-src {
            color: ${token("colors.eds.palette.accent.red200")};
        }
        body .gist .pl-s1 .pl-s2,
        body .gist .pl-sv {
            color: ${token("colors.eds.palette.accent.cyan200")};
        }
        body .gist .pl-smi,
        body .gist .pl-smp,
        body .gist .pl-stj,
        body .gist .pl-vo {
            color: ${token("colors.eds.palette.accent.purple200")};
        }
        body .gist .pl-mi1,
        body .gist .pl-mdht {
            color: ${token("colors.eds.palette.static.white")};
            background: ${token("colors.eds.background.backdrop.strong")};
        }
        body .gist .pl-md,
        body .gist .pl-mdhf,
        body .gist .pl-id,
        body .gist .pl-ii {
            color: ${token("colors.eds.palette.static.white")};
            background: ${token("colors.eds.palette.accent.orange200")};
        }
		div.gist div.gist-meta {
			background-color: ${token("colors.eds.background.elevated.high.default")};
            color: ${token("colors.eds.text.disabled.default")};
		}
	</style>
`;
